import { Col, Row, Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useFormContext } from '../../components/forms/forms';
import { InlineLink } from '../../components/typography';
import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import { DateRangePicker } from '../../components/dateRange/DateRangePicker';
import { useLayoutElementsStyles } from '../../components/layout/layoutElements.styles';
import { useReportsSharedStyles } from './reportsShared.styles';

export function ReportsDateRange() {
  const { formInstance, forceUpdate } = useFormContext();
  const { styles } = useReportsSharedStyles();
  const { styles: layoutStyles } = useLayoutElementsStyles();

  return (
    <div className={styles.reportsSectionContent}>
      <div
        className={classNames(
          styles.reportsSectionTitle,
          'no-margin-form-items'
        )}
      >
        <Typography.Title level={3}>
          3. <FormattedMessage id="reports.dateRange.title" />
        </Typography.Title>
        <InlineLink
          textId="buttons.clear"
          onClick={() => {
            formInstance.setFieldsValue({ dateStart: null, dateEnd: null });
            forceUpdate();
          }}
        />
      </div>
      <div className={styles.selectionSectionTitle}>
        <Row
          className={layoutStyles.flex1}
          gutter={pxToNumber(cssVariables.spaceNorm2)}
        >
          <Col span={12} className={layoutStyles.flexCol}>
            <FormattedMessage id="reports.dateRange.start" />
          </Col>
          <Col span={12} className={layoutStyles.flexCol}>
            <FormattedMessage id="reports.dateRange.end" />
          </Col>
        </Row>
      </div>
      <div className={styles.selectionSectionBody}>
        <DateRangePicker
          form={formInstance}
          extended
          onDateChange={forceUpdate}
        />
      </div>
    </div>
  );
}
